type HeyLightFailureReasonKey =
  | "null"
  | "credit_check_decline"
  | "id_check_decline"
  | "address_not_found_decline"
  | "success";

const HEYLIGHT_FAILURE_REASON_LABELS: Record<HeyLightFailureReasonKey, string> =
  {
    null: "L'utente non ha completato la procedura sulla pagina di finanziamento",
    credit_check_decline:
      "Controllo del credito non superato (non idoneo al finanziamento)",
    id_check_decline: "Verifica dei documenti d'identità fallita",
    address_not_found_decline: "Indirizzo non valido",
    success: "Verifica superata",
  };

export function getHeyLightFailureReasonLabel(
  reason:
    | "credit_check_decline"
    | "id_check_decline"
    | "address_not_found_decline"
    | "success"
    | null
    | undefined,
): string {
  const key = (reason ?? "null") as HeyLightFailureReasonKey;
  return HEYLIGHT_FAILURE_REASON_LABELS[key];
}
